import { render, staticRenderFns } from "./AllAudios.vue?vue&type=template&id=3a3813b8&scoped=true&"
import script from "./AllAudios.vue?vue&type=script&lang=js&"
export * from "./AllAudios.vue?vue&type=script&lang=js&"
import style0 from "./AllAudios.vue?vue&type=style&index=0&id=3a3813b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3813b8",
  null
  
)

export default component.exports